{
    "welcome": "Welcome!",
    "loginForm": {
        "title": "Enter",
        "login": "Login / e-mail",
        "password": "Password",
        "forgotPassword": "Forgot password?",
        "enterBtn": "Enter"
    },
    "menu": {
        "schedule": "Schedule",
        "employees": "Employees",
        "shift_exchange": "Shift exchange",
        "analytics": "Analytics",
        "settings": "Settings"
    }
}